// START always import these first!!
import './sentry/initSentry';
import './publicPath';
// END always import these first!!
import initClient from './initClient';

initClient();
